module.exports = __webpack_public_path__ + "img/u360.f0d19d55.svg";